// Various utility functions. It's unclear what the best way to break them up is,
// so for now they are all in one file.

import type { Font, FontDescription } from '@/api/types/font';

export const toDecimal = (num: number, decimal = 0): number => {
    const factor = 10 ** decimal;
    return Math.round((num + Number.EPSILON) * factor) / factor;
};

export function timeAgo(dateString: string) {
    const now = new Date();
    const past = new Date(dateString);
    const secondsAgo = Math.floor((now.getTime() - past.getTime()) / 1000);

    const intervals = [
        { label: 'year', seconds: 31536000 },
        { label: 'month', seconds: 2592000 },
        { label: 'day', seconds: 86400 },
        { label: 'hour', seconds: 3600 },
        { label: 'minute', seconds: 60 },
        { label: 'second', seconds: 1 },
    ];

    for (const interval of intervals) {
        const count = Math.floor(secondsAgo / interval.seconds);
        if (count >= 1) {
            return `${count} ${interval.label}${count !== 1 ? 's' : ''} ago`;
        }
    }
    return 'Just now';
}

export function getFontHash(font: Font | FontDescription): string {
    return `${font.family.toLowerCase()}-${font.style.toLowerCase()}-${font.weight}`;
}

const loadedFonts: Array<number> = [];

export function loadFontFile(font: Font, file: ArrayBuffer): Promise<boolean> {
    const id = font.id;
    if (loadedFonts.includes(id)) {
        return Promise.resolve(true);
    }
    loadedFonts.push(id);

    const fontFace = new FontFace(font.family, file, { style: font.style, weight: font.weight.toString() });
    return fontFace
        .load()
        .then((loadedFont) => {
            document.fonts.add(loadedFont);
            return true;
        })
        .catch((error) => {
            console.error('Error loading font:', font, error);
            return false;
        });
}

// FIXME: Typing
export function debounce(func, delay: number) {
    let timeoutId: number | null = null;
    return (...args) => {
        clearTimeout(timeoutId);
        timeoutId = setTimeout(() => {
            func(...args);
        }, delay);
    };
}
